import urls from './urls';
import axios from 'axios';

class liveStreamApi {
  static getListLiveStreams() {
    // this.restClient = new RestClient();
    // return this.restClient.execute(urls.GET_LIST_LIVE_STREAMS, ApiMethod.GET, null).then(response => {
    //   return response;
    // });
    return axios.get(urls.GET_LIST_LIVE_STREAMS, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }

  static getListLiveStreamsInRoom(roomId, {offset, size, search}) {
    // this.restClient = new RestClient();
    const url = urls.GET_LIST_LIVE_STREAMS_IN_ROOM.replace('{roomId}', roomId);
    // let url = urls.GET_LIST_LIVE_STREAMS_IN_ROOM
    //   .replace(':offset', offset)
    //   .replace(':size', size);
    // if (search && typeof search === 'string') {
    //   url = `${url}?search=${search}`; //advance search
    // } else {
    //   url = `${url}?search=roomid${roomId}`; // we search by roomId
    // }
    // return this.restClient.execute(url, ApiMethod.GET, null).then(response => {
    //   return response;
    // });
    return axios.get(url, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
    // return axios.get(url, { baseURL: urls.LIVE_STREAM_HOST, headers: { isAnonymous: true } }).then(res => res);
  }

  static getListViewerLiveStream(streamId) {
    // this.restClient = new RestClient();
    const url = urls.GET_LIST_VIEWER_LIVE_STREAM.replace('{streamId}', streamId);
    // return this.restClient.execute(url, ApiMethod.GET, null).then(response => {
    //   return response;
    // });
    return axios.get(url, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }

  static startLiveStream(xmppId, roomId, streamName) {
    // this.restClient = new RestClient();
    const url = urls.CREATE_LIVE_STREAM.replace('{roomId}', roomId);
    // return this.restClient.execute(url, ApiMethod.POST, streamName).then(res => {
    //   return res;
    // });
    return axios.post(url, streamName, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }

  static watchLiveStream(xmppId, streamId) {
    // this.restClient = new RestClient();
    const url = urls.WATCH_LIVE_STREAM.replace('{streamId}', streamId);
    // return this.restClient.execute(url, ApiMethod.POST, null).then(res => {
    //   return res;
    // });
    return axios.post(url, null, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }

  static endLiveStream(xmppId, streamId) {
    // this.restClient = new RestClient();
    const url = urls.DELETE_LIVE_STREAM.replace('{streamId}', streamId);
    // return this.restClient.execute(url, ApiMethod.DELETE, null).then(res => {
    //   return res;
    // });
    return axios.delete(url, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }

  static uploadThumbnail(formData) {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.UPLOAD_THUMBNAIL_IMAGE_LIVESTREAM;
    try {
      // return this.restClient.execute(url, ApiMethod.POST, formData).then(res => {
      //   return res;
      // });
      return axios.post(url, formData, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
    } catch (e) {
      console.error('Failed upload thumbnail', e);
      throw e;
    }
  }

  static uploadThumbnailUrl(linkUrl, streamId) {
    // this.restClient = new RestClient();
    const url = urls.UPLOAD_THUMBNAIL_URL.replace('{streamId}', streamId);
    const imageUrl = {
      imageUrl: linkUrl,
    };
    // return this.restClient.execute(url, ApiMethod.PUT, imageUrl).then(response => {
    //   return response;
    // });
    return axios.put(url, imageUrl, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }

  static createPublicLiveStream(params) {
    // this.restClient = new RestClient();
    // return this.restClient.execute(urls.CREATE_PUBLIC_LIVE_STREAM, ApiMethod.POST, params).then(res => {
    //   return res;
    // });
    const url = urls.CREATE_PUBLIC_LIVE_STREAM;
    return axios.post(url, params, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }

  static cleanUpLiveStream(roomId) {
    // this.restClient = new RestClient();
    const url = urls.CLEAN_UP_LIVE_STREAM.replace('{roomId}', roomId);
    // return this.restClient.execute(url, ApiMethod.POST).then(res => {
    //   return res;
    // });
    return axios.post(url, null, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }).then(res => res);
  }
}
export default liveStreamApi;
